// db/mail-template-definition.ts
import { baseConfig } from "@adornis/config/baseConfig.js";
import {
  buildAndSendMessage,
  buildMessage
} from "../server/buildMessage.js";
var mailTemplateDefinitions = {};
var defineMailTemplate = (mailType, definition) => {
  mailTemplateDefinitions[mailType] = definition;
  if (baseConfig.get("ENVIRONMENT") !== "node")
    return (...args) => {
      throw new Error("can only be used on the server");
    };
  return (...args) => ({
    send: async (options) => {
      const { data, attachments, scope } = await definition.getMailData(...args);
      await buildAndSendMessage({
        mailInfos: data,
        attachments,
        mailType,
        scope,
        ...options
      });
    },
    build: async (options) => {
      const { data, attachments, scope } = await definition.getMailData(...args);
      return buildMessage({
        mailInfos: data,
        attachments,
        mailType,
        scope,
        ...options
      });
    }
  });
};
export {
  defineMailTemplate,
  mailTemplateDefinitions
};
